import React, { useState, useEffect } from 'react'

function Vita() {
  const [pressePosts, setPressePosts] = useState([])
  const [pageContent, setPageContent] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Fetch page content for 'vita'
        const pageResponse = await fetch('/wp-json/wp/v2/pages?slug=vita')
        const pageData = await pageResponse.json()
    
        if (pageData.length > 0) {
          setPageContent(pageData[0].content.rendered)
        }

        // Fetch custom post type 'presse'
        const presseResponse = await fetch('/wp-json/wp/v2/presse')
        const presseData = await presseResponse.json()
        
        if (Array.isArray(presseData)) {
          // Add the decode function
          const decodeHTML = (html) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = html
            return txt.value
          }

          // Update the formattedPressePosts mapping
          const formattedPressePosts = presseData.map(post => ({
            id: post.id,
            title: decodeHTML(post.title.rendered), // Apply decoding here
            year: post.acf?.year_vita || '',
            externalLink: post.acf?.external_link || '',
            documentPdf: post.acf?.document_pdf || '',
            slug: post.slug
          }))
          setPressePosts(formattedPressePosts)
        }
        
        setLoading(false)
      } catch (error) {
        console.error('Error fetching content:', error)
        setLoading(false)
      }
    }

    fetchContent()
  }, [])

  if (loading) return <div className="loading">Loading...</div>

  return (
    <main className="vita-page">
      <h1 className="page-title">Vita</h1>
      
      <div 
        className="vita-content"
        dangerouslySetInnerHTML={{ __html: pageContent }}
      />
      
      <section className="presse-section">
        <h2 className="section-title">Presse</h2>
        <div className="press-posts">
          {pressePosts.map(post => (
            <article key={post.id} className="press-post">
              <div className="title-date-wrapper">
                <div className="post-date">
                  {post.year}
                </div>
                <div className="title-links-wrapper">
                  <h3>{post.title}</h3>
                  <div className="post-links">
                    {post.externalLink && (
                      <a 
                        href={post.externalLink} 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        Link zur Website ↪
                      </a>
                    )}
                    {post.documentPdf && (
                      <a 
                        href={post.documentPdf} 
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Dokument herunterladen
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  )
}

export default Vita